export const simpleCalloutCardsButtonClicked = (text, target) => ({
  type: 'SimpleCalloutCards Button Clicked',
  data: {
    text,
    target,
  },
});
